import { KYMW2000Model } from '../kymw2000.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { TempSelectedSummary } from '../vo/temp-selected-summary.model';

// レスポンス構造
interface GetPlanTempSelectedSummaryResponse {
  SelectedNumList: {
    ClassCode: string,
    ClassName: string,
    ClassGoodsCount: number,
    FreezedGoodsCount: number,
    RefrigeratedGoodsCount: number,
    RoomTempGoodsCount: number,
    VegetableGoodsCount: number,
    BreadGoodsCount: number,
    OtherStockedGoodsCount: number,
  }[],
  SelectedTotalNum: {
    ClassGoodsCount: number,
    FreezedGoodsCount: number,
    RefrigeratedGoodsCount: number,
    RoomTempGoodsCount: number,
    VegetableGoodsCount: number,
    BreadGoodsCount: number,
    OtherStockedGoodsCount: number,
  },
}

/**
 * サイクル商品選定対象媒体一覧取得するサービス
 *
 * @export GetPlanTempSelectedSummaryService
 * @class GetPlanTempSelectedSummaryService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanTempSelectedSummaryService extends PlessJsonResponderSub<any> {

  private model: KYMW2000Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanTempSelectedSummaryService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetPlanTempSelectedSummary: {
          condition: {
            MediumType: this.model.mediumType,
            OrderCode: this.model.orderCode,
            CoopCode: this.model.deptCoopCode,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPlanTempSelectedSummaryService
   */
  execute(model: KYMW2000Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getPlanTempSelectedSummary', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanTempSelectedSummaryService
   */
  success(data: GetPlanTempSelectedSummaryResponse): void {
    if (data !== null) {
      this.model.tempDeptRaw = [
        new TempSelectedSummary(data.SelectedNumList, data.SelectedTotalNum)
      ];
      if (this.calbak) this.calbak();
    }
  }
}
